import {Button, Col, Flex, Row, Tooltip} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowUpFromBracket, faClose, faFile, faMusic} from "@fortawesome/free-solid-svg-icons";
import React, {ReactNode} from "react";
import {FilesBrowserModal} from "../routes/common/FilesBrowser";
import {useCookies} from "react-cookie";
import {useAppSelector} from "../feature/tools";

export const UploadGrid = (props: {
    projectId?: string;
    storyId?: string;
    files: string[],
    onUpload: (file: string) => void,
    onDelete: (file: string) => void,
}) => {
    const [browserAssetsVisible, setBrowserAssetsVisible] = React.useState(false)
    const user = useAppSelector(state => state.users.creator)

    return (
        <Row gutter={[16, 16]} style={{width: "100%"}}>
            {props.files.map((file, index) => <Col span={4}>
                <UploadGridItem onDeleteClick={() => props.onDelete(file)}>
                    {(file.endsWith('.mp3')) ?
                        <FontAwesomeIcon icon={faMusic} size={'2xl'}/> :
                        (file.endsWith('.json')) ?
                            <FontAwesomeIcon icon={faFile} size={'2xl'}/> :
                        <img style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: 8,
                            objectFit: 'cover'
                        }}
                             src={file}
                             alt={file}/>}
                </UploadGridItem></Col>
            )}
            <Col span={6} onClick={() => {
                setBrowserAssetsVisible(true)
            }}
                 style={{cursor: 'pointer'}}>
                <UploadGridItem><FontAwesomeIcon icon={faArrowUpFromBracket}/></UploadGridItem></Col>
            {browserAssetsVisible ? <FilesBrowserModal
                root={(user?.id + "/") + (props.projectId ? (props.projectId + "/") : "") + (props.storyId ? (props.storyId + "/") : "")}
                onDismiss={() => setBrowserAssetsVisible(false)}
                onSelect={(url) => {
                    props.onUpload(url)
                    setBrowserAssetsVisible(false)
                }}
                types={['images', 'audio', 'documents']}
            /> : ''}
        </Row>
    )
}

const UploadGridItem = (props: {
    children: React.ReactNode,
    onDeleteClick?: () => void,
}) => {
    return (
        <Flex
            align={'center'} justify={'center'} className="custom-item-renderer" style={{
            width: '80px',
            height: '80px',
            position: "relative",
            borderRadius: 8,
            border: '2px dashed #eee',
        }}>
            {props.children}
            {props.onDeleteClick ?
                <Button
                    danger={true}
                    size="small"
                    type={'primary'}
                    shape={'circle'}
                    icon={<FontAwesomeIcon icon={faClose}/>}
                    onClick={() => {
                        props.onDeleteClick?.()
                    }}
                    style={{
                        position: 'absolute',
                        right: '-6px',
                        top: '-8px',
                        width: 24,
                        height: 24
                    }}/> : ''}
        </Flex>
    )
}